import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }

import Hexagon from '@/components/RAOS/HexagonRAOS.vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n'
interface Props {
    hexaTitle1: string
    hexaTitle2: string
    hexaTitle3: string
    hexaTitle4: string
    ip: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapDialogRAOS',
  props: {
    hexaTitle1: {},
    hexaTitle2: {},
    hexaTitle3: {},
    hexaTitle4: {},
    ip: {}
  },
  setup(__props: any) {

const { t } = useI18n()




return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    color: "blue",
    elevation: "8",
    class: "pa-3",
    width: "580"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.ip), 1),
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          _createVNode(Hexagon, {
            class: "mx-8",
            color: "green",
            title: _ctx.hexaTitle1,
            subtitle: "Mbps",
            sizeTitle: 35,
            sizeSubTi: 15,
            icon: "mdi-chart-timeline-variant"
          }, null, 8, ["title"]),
          _createVNode(Hexagon, {
            class: "mx-8",
            color: "green",
            title: _ctx.hexaTitle2,
            subtitle: _unref(t)('labels.latency'),
            sizeSubTi: 15,
            sizeTitle: 25,
            icon: "mdi-speedometer"
          }, null, 8, ["title", "subtitle"]),
          _createVNode(Hexagon, {
            class: "mx-8",
            color: "green",
            title: _ctx.hexaTitle3,
            subtitle: _unref(t)('labels.loss'),
            sizeSubTi: 15,
            sizeTitle: 25,
            icon: "mdi-wifi-arrow-up"
          }, null, 8, ["title", "subtitle"]),
          _createVNode(Hexagon, {
            class: "mx-8",
            color: "green",
            title: _ctx.hexaTitle4,
            subtitle: _unref(t)('labels.uptime'),
            sizeSubTi: 15,
            sizeTitle: 25,
            icon: "mdi-chart-bar"
          }, null, 8, ["title", "subtitle"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})